const BASE_URL = process.env.REACT_APP_APPS_SCRIPT_URL;

async function request(body) {
  const res = await fetch(BASE_URL, {
    method: 'POST',
    redirect: 'follow',
    body: JSON.stringify(body),
  });
  if (!res.ok) throw new Error(`API error ${res.status}`);
  return res.json();
}

const get = (action, params = {}) => request({ action, ...params });
const post = (body) => request(body);

export const getFlocks = () => get('getFlocks');
export const createFlock = (data) => post({ action: 'createFlock', data });
export const updateFlock = (flockId, data) => post({ action: 'updateFlock', flockId, data });
export const fileFlock = (flockId) => post({ action: 'fileFlock', flockId });
export const deleteFlock = (flockId) => post({ action: 'deleteFlock', flockId });
export const getTempReadings = (flockId) => get('getTempReadings', { flockId });
export const addTempReading = (data) => post({ action: 'addTempReading', data });
export const deleteTempReading = (id) => post({ action: 'deleteTempReading', id });
export const getSettlement = (flockId) => get('getSettlement', { flockId });
export const saveSettlement = (data) => post({ action: 'saveSettlement', data });
